/**
 * DeliverButton — nút "Đã trả ảnh cho khách" của đơn ảnh thẻ, dùng chung cho
 * khối Lịch ê-kíp (DeliverBlock) và dải tiến trình trong đơn (QĐ 0317, bản vẽ
 * Phần 4). Tách ra để hai nơi giữ ĐÚNG MỘT luật:
 *
 * Đã có ảnh bàn giao (tải sẵn từ lúc nhận ca), hoặc khách đã ký nghiệm thu
 * (máy chủ miễn ảnh — QĐ 0107, CEO giữ nguyên 29/09/2026) ⇒ giao thẳng, không
 * bắt chụp lại. Chưa có cả hai ⇒ mở khung chụp ảnh bàn giao trước, gửi xong mới
 * chuyển đơn sang "đã giao" (máy chủ chặn lần nữa). Cùng luật với nút "Đã giao"
 * ở đầu chi tiết đơn.
 */
import { useState } from "react";
import { toast } from "sonner";

import { useDeliverOrder } from "./api";
import { ProofCaptureSheet } from "./ProofCaptureSheet";
import { useDeliverNeedsPhoto } from "./useDeliverNeedsPhoto";

export function DeliverButton({ orderId, className }: { orderId: string; className?: string }) {
  const [open, setOpen] = useState(false);
  const deliverM = useDeliverOrder();
  const needsPhoto = useDeliverNeedsPhoto(orderId);
  const deliver = () =>
    deliverM.mutate(orderId, {
      onSuccess: () => toast.success("Đã xác nhận giao ảnh cho khách"),
      onError: (err: unknown) =>
        toast.error(err instanceof Error ? err.message : "Xác nhận giao thất bại"),
    });
  return (
    <>
      <button
        type="button"
        onClick={() => (needsPhoto ? setOpen(true) : deliver())}
        disabled={deliverM.isPending}
        className={
          className ??
          "rounded-md border-0 bg-gradient-to-br from-[var(--color-success)] to-[var(--color-success)]/80 px-5 py-2 text-xs font-bold text-white shadow-md disabled:opacity-60"
        }
      >
        {deliverM.isPending ? "Đang xác nhận…" : "Đã trả ảnh cho khách"}
      </button>
      <ProofCaptureSheet
        orderId={orderId}
        kind="delivery"
        withNote
        open={open}
        onOpenChange={setOpen}
        onDone={deliver}
      />
    </>
  );
}
